@if (plans.length > 0) {
  <section class="pricing-section">
    <h2>{{ 'plan.pricingTitle' | t }}</h2>
    <p class="pricing-intro">{{ 'plan.pricingIntro' | t }}</p>
    <p class="pricing-trial">{{ 'plan.pricingTrial' | t }}</p>

    <div class="pricing-grid">
      @for (p of plans; track p.code) {
        <div class="pricing-card" [class.highlight]="p.code === 'premium'">
          <h3>{{ planName(p.code) | t }}</h3>
          <!-- cena z katalogu Paddle; gdy Paddle.js nie wystartuje, zapas
               z tabeli plan (backend trzyma go zgodnym z katalogiem) -->
          <p class="price">
            @if (priceLoading(p)) {
              <!-- szkielet MUSI wyprzedzac cene zapasowa: inaczej karta
                   mignelaby kwota z bazy, zanim odpowie Paddle -->
              <span class="price-skeleton"></span>
            } @else if (displayPrice(p)) {
              {{ 'plan.perYearIntl' | t: { price: displayPrice(p) } }}
            } @else {
              {{ 'plan.priceFree' | t }}
            }
          </p>
          <ul class="features">
            <li>
              @if (p.person_limit) {
                {{ 'plan.featurePersons' | t: { count: personLimit(p) } }}
              } @else {
                {{ 'plan.featurePersonsUnlimited' | t }}
              }
            </li>
            <li>{{ 'plan.featureStorage' | t: { size: formatBytes(p.storage_limit_bytes) } }}</li>
            <!-- GEDCOM jest w każdym planie: wchodzi i wychodzi bez ograniczeń
                 (poza limitem osób planu przy imporcie) -->
            <li>✓ {{ 'plan.featureGedcom' | t }}</li>
            <li [class.feature-off]="!p.pdf_export">
              {{ p.pdf_export ? '✓' : '✕' }} {{ 'plan.featurePdf' | t }}
            </li>
            <li [class.feature-off]="!p.relation_search">
              {{ p.relation_search ? '✓' : '✕' }} {{ 'plan.featureRelation' | t }}
            </li>
            <li [class.feature-off]="!p.invite_users">
              {{ p.invite_users ? '✓' : '✕' }} {{ 'plan.featureCollaborators' | t }}
            </li>
            <!-- Wsparcie e-mail idzie za samym faktem platnosci (plan.paid =
                 plan ma cene w katalogu Paddle), wiec nie potrzebuje wlasnej
                 kolumny w tabeli plan - nie ma tu czego egzekwowac w kodzie -->
            <li [class.feature-off]="!p.paid">
              {{ p.paid ? '✓' : '✕' }} {{ 'plan.featureSupport' | t }}
            </li>
          </ul>
        </div>
      }
    </div>

    <!-- Abonament dotyczy konkretnego drzewa, wiec kupuje sie go w jego
         ustawieniach - tu pokazujemy tylko, co oferuja plany -->
    <p class="pricing-where">{{ 'plan.buyInTreeSettings' | t }}</p>

    @if (!loggedIn) {
      <div class="pricing-cta">
        <button type="button" class="cta-signup" (click)="onSignup()">
          {{ 'plan.pricingCta' | t }}
        </button>
      </div>
    }
  </section>
}
